import Api from "./Api";

export default {
  createOrderInDB(order) {
    return Api().post("createOrderInDB", order);
  },
  getOrders(obj) {
    return Api().post("order", obj);
  },
  getnumberOfDaysToDelivery() {
    return Api().get("order/daysNumberForDelivery");
  },
  getOrder(ord) {
    return Api().get("order/" + ord);
  },
  getTaxPercent() {
    return Api().get("order/TaxPercent");
  },
  updateOrder(obj) {
    return Api().post("order/updateOrder", obj);
  },
  updateCart(obj) {
    return Api().post("order/updateCart", obj);
  },
  getUserCart() {
    return Api().get("order/getUserCart");
  },
  updateLinesCart(obj) {
    return Api().post("order/updateLinesCart", obj);
  },
  clearCart(obj) {
    return Api().post("order/clearCart", obj);
  },
  updateOrderLine(obj) {
    return Api().post("orderline", obj);
  },
  removeOrderLine(obj) {
    return Api().post("order/removeorderline", obj);
  },
  sendOrder(order) {
    return Api().post("order/sendOrder", order);
  },
  printOrder(ordName) {
    return Api().get("print-procedure", {
      params: { fieldName: ordName, procedureName: "WWWSHOWORDER" },
      responseType: "blob",
    });
  },
  printDelivery(docNum) {
    return Api().get("print-procedure", {
      params: { fieldName: docNum, procedureName: "NIRR_WWWSHOWDOC_D" },
      responseType: "blob",
    });
  },
  printDeliveryEnglish(docNum) {
    return Api().get("print-procedure", {
      params: { fieldName: docNum, procedureName: "NIRM_WWWSHOWDOC_D" },
      responseType: "blob",
    });
  },
  getOrdersToAprove() {
    return Api().post("order/getOrderToAprove");
  },
  getAwatingOrders() {
    return Api().get("order/getAwatingOrders");
  },
  getMinOrderSum() {
    return Api().get("settings/minOrderSum");
  },
};
